<template>
  <div>
    <div class="content-body">
      <div class="container pd-x-0">
        <div
          class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30"
        >
          <div>
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb breadcrumb-style1 mg-b-10">
                <li class="breadcrumb-item"><a href="#">Хүсэлтүүд</a></li>
                <li class="breadcrumb-item active" aria-current="page">
                  Статистик
                </li>
              </ol>
            </nav>
            <h4 class="mg-b-0 tx-spacing--1">Системд тавтай морил</h4>
          </div>
        </div>

        <div class="row row-xs">
          <div class="col-sm-6 col-lg-3">
            <div class="card card-body bg-secondary">
              <h6
                class="tx-uppercase tx-11 tx-spacing-1 tx-white tx-semibold mg-b-8"
              >
                Нийт
              </h6>
              <div class="d-flex d-lg-block d-xl-flex align-items-end">
                <h3 class="tx-white tx-rubik mg-b-0 mg-r-5 lh-1">
                  {{ dashboard.med.all }}
                </h3>
                <p class="tx-11 tx-white mg-b-0">
                  <span class="tx-medium">бүртгэлтэй эм</span>
                </p>
              </div>
            </div>
          </div>
          <!-- col -->
          <div class="col-sm-6 col-lg-3 mg-t-10 mg-sm-t-0">
            <div class="card card-body bg-warning op-7">
              <h6 class="tx-uppercase tx-11 tx-spacing-1 tx-semibold mg-b-8">
                Хугацаа дөхсөн
              </h6>
              <div class="d-flex d-lg-block d-xl-flex align-items-end">
                <h3 class="tx-rubik mg-b-0 mg-r-5 lh-1">
                  {{ dashboard.med.expireIn3Month }}
                </h3>
                <p class="tx-11 mg-b-0">
                  <span class="tx-medium">бүртгэлтэй эм</span>
                </p>
              </div>
            </div>
          </div>
          <!-- col -->
          <div class="col-sm-6 col-lg-3 mg-t-10 mg-lg-t-0">
            <div class="card card-body bg-success">
              <h6
                class="tx-uppercase tx-11 tx-spacing-1 tx-white tx-semibold mg-b-8"
              >
                Тусгай зөвшөөрөл
              </h6>
              <div class="d-flex d-lg-block d-xl-flex align-items-end">
                <h3 class="tx-white tx-rubik mg-b-0 mg-r-5 lh-1">
                  {{
                    hasPermission(["vetmedadmin"])
                      ? dashboard.tusgaiZovshoorol.all
                      : dashboard.tusgaiZovshoorol.all > 0
                      ? "ХЭВИЙН"
                      : "ДУУССАН"
                  }}
                </h3>
                <p
                  v-if="hasPermission(['vetmedadmin'])"
                  class="tx-11 tx-white mg-b-0"
                >
                  <span class="tx-medium">нийт олгосон</span>
                </p>
              </div>
            </div>
          </div>
          <!-- col -->
          <div class="col-sm-6 col-lg-3 mg-t-10 mg-lg-t-0">
            <div class="card card-body bg-pink">
              <h6
                class="tx-uppercase tx-11 tx-spacing-1 tx-white tx-semibold mg-b-8"
              >
                Хугацаа дөхсөн
              </h6>
              <div class="d-flex d-lg-block d-xl-flex align-items-end">
                <h3 class="tx-white tx-rubik mg-b-0 mg-r-5 lh-1">
                  {{ dashboard.tusgaiZovshoorol.expireIn3Month }}
                </h3>
                <p class="tx-11 tx-white mg-b-0">
                  <span class="tx-medium">Тусгай зөвшөөрөл</span>
                </p>
              </div>
            </div>
          </div>
          <!-- col -->
          <div class="col-md-6 col-xl-4 mg-t-10 order-md-1 order-xl-0">
            <div class="card ht-lg-100p">
              <div
                class="card-header d-flex align-items-center justify-content-between"
              >
                <h6 class="mg-b-0">
                  Сүүлд олгосон эм, бэлдмэл импортлох лицензүүд
                </h6>
              </div>
              <!-- card-header -->
              <div class="card-body pd-0">
                <div class="table-responsive">
                  <table
                    class="table table-borderless table-dashboard table-dashboard-one"
                  >
                    <thead class="thead-primary">
                      <tr>
                        <th class="wd-40">Эм</th>
                        <th class="wd-25 text-right">Импортлогч</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        @click="showDetail(t)"
                        role="button"
                        v-for="(t, i) in importedMeds"
                        :key="i"
                      >
                        <td class="tx-medium">{{ t.task }}</td>
                        <td class="text-right">{{ t.organizationTaskName }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- table-responsive -->
              </div>
              <!-- card-body -->
              <div class="card-footer text-center tx-13">
                <a
                  @click="
                    $router.push({
                      name: 'vetMedAcceptedMeds',
                      params: { ot: 477 }
                    })
                  "
                  role="button"
                  class="link-03"
                >
                  Бүгдийг үзэх
                  <i class="icon ion-md-arrow-down mg-l-5"></i>
                </a>
              </div>
            </div>
            <!-- card -->
          </div>
          <!-- col -->
          <div class="col-lg-12 col-xl-8 mg-t-10">
            <div class="card mg-b-10">
              <div
                class="card-header pd-t-20 d-sm-flex align-items-start justify-content-between bd-b-0 pd-b-0"
              >
                <div>
                  <h6 class="mg-b-5">
                    Эм, бэлдмэлийн улсын бүртгэлийн гэрчилгээ
                  </h6>
                  <p class="tx-13 tx-color-03 mg-b-0">
                    Хугацаа сунгах эсвэл хүчинтэй хугацааг цуцлах шаарлдлагатай
                  </p>
                </div>
                <div class="d-flex mg-t-20 mg-sm-t-0">
                  <div class="btn-group flex-fill">
                    <button
                      @click="
                        expireMeds.mode = 0;
                        initExpireMeds();
                      "
                      :class="{ active: expireMeds.mode == 0 }"
                      class="btn btn-white btn-xs"
                    >
                      Хугацаа дөхсөн
                    </button>
                    <button
                      @click="
                        expireMeds.mode = 1;
                        initExpireMeds();
                      "
                      :class="{ active: expireMeds.mode == 1 }"
                      class="btn btn-white btn-xs"
                    >
                      Хугацаа дууссан
                    </button>
                  </div>
                </div>
              </div>
              <!-- card-header -->
              <div class="card-body pd-y-30">
                <div class="d-sm-flex">
                  <div class="media">
                    <div
                      class="wd-40 wd-md-50 ht-40 ht-md-50 bg-primary tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-6"
                    >
                      <feather type="bar-chart-2"></feather>
                    </div>
                    <div class="media-body">
                      <h6
                        class="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold tx-nowrap mg-b-5 mg-md-b-8"
                      >
                        Хугацаандаа байгаа
                      </h6>
                      <h4
                        class="tx-20 tx-sm-18 tx-md-20 tx-normal tx-rubik mg-b-0"
                      >
                        {{ expireMeds.allCount }}
                      </h4>
                    </div>
                  </div>
                  <div class="media mg-t-20 mg-sm-t-0 mg-sm-l-15 mg-md-l-40">
                    <div
                      class="wd-40 wd-md-50 ht-40 ht-md-50 bg-danger tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-5"
                    >
                      <feather type="bar-chart-2"></feather>
                    </div>
                    <div class="media-body">
                      <h6
                        class="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold mg-b-5 mg-md-b-8"
                      >
                        Хугацаа хэтэрсэн
                      </h6>
                      <h4
                        class="tx-20 tx-sm-18 tx-md-20 tx-normal tx-rubik mg-b-0"
                      >
                        {{ expireMeds.expiredCount }}
                      </h4>
                    </div>
                  </div>
                  <div class="media mg-t-20 mg-sm-t-0 mg-sm-l-15 mg-md-l-40">
                    <div
                      class="wd-40 wd-md-50 ht-40 ht-md-50 bg-warning tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-4"
                    >
                      <feather type="bar-chart-2"></feather>
                    </div>
                    <div class="media-body">
                      <h6
                        class="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold mg-b-5 mg-md-b-8"
                      >
                        Хугацаа дөхсөн
                      </h6>
                      <h4
                        class="tx-20 tx-sm-18 tx-md-20 tx-normal tx-rubik mg-b-0"
                      >
                        {{ expireMeds.expireIn3MonthCount }}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
              <!-- card-body -->
              <div class="table-responsive">
                <table class="table table-striped table-dashboard mg-b-0">
                  <thead>
                    <tr>
                      <th class="text-right text-nowrap">-</th>
                      <th class="text-right text-nowrap">Олон улсын нэршил</th>
                      <th class="text-right text-nowrap">Худалдааны нэр</th>
                      <th class="text-right">Импортлогч</th>
                      <th class="text-right">Гэрчилгээ</th>
                      <th class="text-right">Файл</th>
                      <th>Огноо</th>
                      <th class="text-right text-nowrap">Олгогдсон огноо</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      @click="showDetail({ id: t.emId })"
                      role="button"
                      v-for="(t, i) in expireMeds.list"
                      :key="i"
                    >
                      <td class="tx-medium text-right text-nowrap">
                        <button
                          v-if="
                            hasPermission(['vetmedadmin']) &&
                              expireMeds.mode == 1
                          "
                          @click.stop="
                            expireConfirm(t.emId, t.licenseId, 'med')
                          "
                          class="btn btn-xs btn-outline-danger"
                        >
                          Бүртгэлтэй эмээс хасах
                        </button>
                      </td>
                      <td class="tx-medium text-right text-nowrap">
                        {{ t.inn }}
                      </td>
                      <td class="text-right tx-teal text-nowrap">
                        {{ t.saleName }}
                      </td>
                      <td class="text-right tx-primary text-nowrap">
                        <a
                          @click.stop="showDetail({ id: t.companyId })"
                          role="button"
                          >{{ t.companyName }}</a
                        >
                      </td>
                      <td class="tx-medium text-right text-nowrap">
                        <a
                          v-if="t.licenseId != null && t.licenseId > 0"
                          @click.stop="showFile(t.licenseId)"
                          role="button"
                          ><i class="icon ion-md-attach"></i> харах</a
                        >
                      </td>
                      <td class="tx-medium text-right text-nowrap">
                        <a
                          v-if="t.certFileId != null && t.certFileId > 0"
                          @click.stop="showFile(t.certFileId)"
                          role="button"
                          ><i class="icon ion-md-attach"></i> харах</a
                        >
                      </td>
                      <td class="tx-color-03 tx-normal text-nowrap">
                        {{ t.huchintei_ognoo | moment("YYYY.MM.DD HH:mm") }}
                      </td>
                      <td class="tx-color-03 tx-normal text-nowrap">
                        {{ t.olgoson_ognoo | moment("YYYY.MM.DD HH:mm") }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- table-responsive -->
            </div>
            <!-- card -->

            <div class="card card-body ht-lg-100">
              <div @click="exportList(463)" role="button" class="media">
                <span class="tx-color-04">
                  <feather type="download" class="wd-60 ht-60"></feather>
                </span>
                <div class="media-body mg-l-20">
                  <h6 class="mg-b-10">Жагсаалтыг EXCEL файлаар татаж авах.</h6>
                  <p class="tx-color-03 mg-b-0">
                    МХугацаа дууссан болон дуусах хугацаа дөхсөн эм бэлдмэлүүд.
                  </p>
                </div>
              </div>
              <!-- media -->
            </div>
          </div>
          <!-- col -->

          <div class="col-md-6 col-xl-4 mg-t-10 order-md-1 order-xl-0">
            <div class="card ht-lg-100p">
              <div
                class="card-header d-flex align-items-center justify-content-between"
              >
                <h6 class="mg-b-0">Сүүлд олгогдсон тусгай зөвшөөрлүүд</h6>
              </div>
              <!-- card-header -->
              <div class="card-body pd-0">
                <div class="table-responsive">
                  <table
                    class="table table-borderless table-dashboard table-dashboard-one"
                  >
                    <thead class="thead-success">
                      <tr>
                        <th class="wd-40">Гэрчилгээ №</th>
                        <th class="wd-25 text-right">Байгууллага</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        @click="showDetail(t)"
                        role="button"
                        v-for="(t, i) in acceptedLicences"
                        :key="i"
                      >
                        <td
                          :style="{
                            'text-decoration': !t.isTender
                              ? 'line-through'
                              : 'inherit'
                          }"
                          class="tx-medium"
                        >
                          {{ t.task }}
                        </td>
                        <td class="text-right">{{ t.organizationTaskName }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- table-responsive -->
              </div>
              <!-- card-body -->
              <div class="card-footer text-center tx-13">
                <a
                  @click="
                    $router.push({
                      name: 'vetMedAcceptedOrgLicences',
                      params: { ot: 476 }
                    })
                  "
                  role="button"
                  class="link-03"
                >
                  Бүгдийг үзэх
                  <i class="icon ion-md-arrow-down mg-l-5"></i>
                </a>
              </div>
            </div>
            <!-- card -->
          </div>
          <!-- col -->

          <div class="col-lg-12 col-xl-8 mg-t-10">
            <div class="card mg-b-10">
              <div
                class="card-header pd-t-20 d-sm-flex align-items-start justify-content-between bd-b-0 pd-b-0"
              >
                <div>
                  <h6 class="mg-b-5">Тусгай зөвшөөрөл</h6>
                  <p class="tx-13 tx-color-03 mg-b-0">
                    Хугацаа сунгах эсвэл хүчинтэй хугацааг цуцлах шаарлдлагатай
                  </p>
                </div>
                <div class="d-flex mg-t-20 mg-sm-t-0">
                  <div class="btn-group flex-fill">
                    <button
                      @click="
                        expireLics.mode = 0;
                        initExpireLecs();
                      "
                      :class="{ active: expireLics.mode == 0 }"
                      class="btn btn-white btn-xs"
                    >
                      Хугацаа дөхсөн
                    </button>
                    <button
                      @click="
                        expireLics.mode = 1;
                        initExpireLecs();
                      "
                      :class="{ active: expireLics.mode == 1 }"
                      class="btn btn-white btn-xs"
                    >
                      Хугацаа дууссан
                    </button>
                  </div>
                </div>
              </div>
              <!-- card-header -->
              <div class="card-body pd-y-30">
                <div class="d-sm-flex">
                  <div class="media">
                    <div
                      class="wd-40 wd-md-50 ht-40 ht-md-50 bg-primary tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-6"
                    >
                      <feather type="bar-chart-2"></feather>
                    </div>
                    <div class="media-body">
                      <h6
                        class="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold tx-nowrap mg-b-5 mg-md-b-8"
                      >
                        Хугацаандаа байгаа
                      </h6>
                      <h4
                        class="tx-20 tx-sm-18 tx-md-20 tx-normal tx-rubik mg-b-0"
                      >
                        {{ expireLics.allCount }}
                      </h4>
                    </div>
                  </div>
                  <div class="media mg-t-20 mg-sm-t-0 mg-sm-l-15 mg-md-l-40">
                    <div
                      class="wd-40 wd-md-50 ht-40 ht-md-50 bg-danger tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-5"
                    >
                      <feather type="bar-chart-2"></feather>
                    </div>
                    <div class="media-body">
                      <h6
                        class="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold mg-b-5 mg-md-b-8"
                      >
                        Хугацаа хэтэрсэн
                      </h6>
                      <h4
                        class="tx-20 tx-sm-18 tx-md-20 tx-normal tx-rubik mg-b-0"
                      >
                        {{ expireLics.expiredCount }}
                      </h4>
                    </div>
                  </div>
                  <div class="media mg-t-20 mg-sm-t-0 mg-sm-l-15 mg-md-l-40">
                    <div
                      class="wd-40 wd-md-50 ht-40 ht-md-50 bg-warning tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-4"
                    >
                      <feather type="bar-chart-2"></feather>
                    </div>
                    <div class="media-body">
                      <h6
                        class="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold mg-b-5 mg-md-b-8"
                      >
                        Хугацаа дөхсөн
                      </h6>
                      <h4
                        class="tx-20 tx-sm-18 tx-md-20 tx-normal tx-rubik mg-b-0"
                      >
                        {{ expireLics.expireIn3MonthCount }}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
              <!-- card-body -->
              <div class="table-responsive">
                <table class="table table-striped table-dashboard mg-b-0">
                  <thead>
                    <tr>
                      <th class="text-right text-nowrap">-</th>
                      <th class="text-right text-nowrap">Дугаар</th>
                      <th class="text-right">ААН</th>
                      <th class="text-right">Лиценз</th>
                      <th class="text-right">Тусгай зөвшөөрөл</th>
                      <th>Олгосон огноо</th>
                      <th class="text-right text-nowrap">Хүчинтэй огноо</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      @click="showDetail({ id: t.companyId })"
                      role="button"
                      v-for="(t, i) in expireLics.list"
                      :key="i"
                    >
                      <td class="tx-medium text-right text-nowrap">
                        <button
                          v-if="
                            hasPermission(['vetmedadmin']) &&
                              expireLics.mode == 1
                          "
                          @click.stop="
                            expireConfirm(t.companyId, t.licenseId, 'lic')
                          "
                          class="btn btn-xs btn-outline-warning"
                        >
                          Тусгай зөвшөөрлийг цуцлах
                        </button>
                      </td>
                      <td class="text-right tx-teal text-nowrap">
                        {{ t.num }}
                      </td>
                      <td class="text-right tx-primary text-nowrap">
                        <a
                          @click.stop="showDetail({ id: t.companyId })"
                          role="button"
                          >{{ t.companyName }}</a
                        >
                      </td>
                      <td class="tx-medium text-right text-nowrap">
                        <a
                          v-if="t.licenseId != null && t.licenseId > 0"
                          @click.stop="showDetail({ id: t.licenseId })"
                          role="button"
                          ><i class="icon ion-md-attach"></i> харах</a
                        >
                      </td>
                      <td class="tx-medium text-right text-nowrap">
                        <a
                          v-if="t.certFileId != null && t.certFileId > 0"
                          @click.stop="showFile(t.certFileId)"
                          role="button"
                          ><i class="icon ion-md-attach"></i> харах</a
                        >
                      </td>
                      <td class="tx-color-03 tx-normal text-nowrap">
                        {{ t.olgoson_ognoo | moment("YYYY.MM.DD HH:mm") }}
                      </td>
                      <td class="tx-color-03 tx-normal text-nowrap">
                        {{ t.huchintei_ognoo | moment("YYYY.MM.DD HH:mm") }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- table-responsive -->
            </div>
            <!-- card -->

            <div class="card card-body ht-lg-100">
              <div @click="exportList(472)" role="button" class="media">
                <span class="tx-color-04"
                  ><feather type="download" class="wd-60 ht-60"></feather
                ></span>
                <div class="media-body mg-l-20">
                  <h6 class="mg-b-10">Жагсаалтыг EXCEL файлаар татаж авах.</h6>
                  <p class="tx-color-03 mg-b-0">
                    МХугацаа дууссан болон дуусах хугацаа дөхсөн эм бэлдмэлүүд.
                  </p>
                </div>
              </div>
              <!-- media -->
            </div>
          </div>
          <!-- col -->
        </div>
        <!-- row -->
      </div>
      <!-- container -->
    </div>

    <task-detail-side
      v-if="taskDialog.id > 0"
      :id.sync="taskDialog.id"
      @on-task-close="taskDialog.id = 0"
    ></task-detail-side>

    <file-dialog
      :show="fileDialog.show"
      :id="fileDialog.id"
      @on-hide="fileDialog.show = false"
    />

    <b-overlay :show="busy" no-wrap style="position: fixed !important">
      <template #overlay>
        <div
          v-if="processing"
          class="text-center p-4 bg-secondary text-light rounded"
        >
          <b-icon icon="info" font-scale="4"></b-icon>
          <div class="mb-3">Түр хүлээнэ үү...</div>
          <b-progress
            min="1"
            max="20"
            :value="18"
            variant="warning"
            height="5px"
            class="mx-n4 rounded-0"
          ></b-progress>
        </div>
        <div
          v-else
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="text-center p-3"
        >
          <p><strong id="form-confirm-label">Итгэлтэй байна уу?</strong></p>
          <div class="d-flex">
            <b-button
              variant="outline-danger"
              class="mr-3"
              @click="busy = false"
            >
              Үгүй
            </b-button>
            <b-button variant="outline-success" @click="expireCmd()"
              >Тийм</b-button
            >
          </div>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import { hasOneOf } from "@/libs/tools";
import { request } from "@/api/all";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

export default {
  components: {
    taskDetailSide: () => ({
      component: import("@/components/task/detail/dialog.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    fileDialog: () => ({
      component: import("@/components/modules/media/preview.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  data: () => ({
    activeGroup: 0,
    showHomePage: false,
    importedMeds: [],
    acceptedLicences: [],
    expireMeds: {
      list: [],
      mode: 0,
      allCount: 0,
      expireIn3MonthCount: 0,
      expiredCount: 0
    },
    expireLicences: [],

    taskDialog: {
      show: false,
      id: 0,
      key: 0
    },
    fileDialog: {
      show: false,
      id: 0
    },
    processing: false,
    busy: false,
    processingObj: {
      id: 0,
      item: 0,
      mode: ""
    },

    expireLics: {
      list: [],
      mode: 0,
      allCount: 0,
      expireIn3MonthCount: 0,
      expiredCount: 0
    },
    dashboard: {
      med: {
        all: 0,
        expireIn3Month: 0
      },
      tusgaiZovshoorol: {
        all: 0,
        expireIn3Month: 0
      }
    }
  }),
  mounted() {
    this.initDashboardStats();

    this.initLatestMeds();
    this.initLatestLicences();

    //this.initExpireMeds();
    request({
      api: { method: "get", url: "Vetmed/ExpireIn3MonthMedCount" },
      store: this.$store
    }).then(res => {
      if (res != false) {
        this.expireMeds.allCount = res.data.allCount;
        this.expireMeds.expireIn3MonthCount = res.data.expireIn3MonthCount;
        this.expireMeds.expiredCount = res.data.expiredCount;
        if (res.data.expiredCount > 0) this.expireMeds.mode = 1;
        else this.expireMeds.mode = 0;

        this.initExpireMeds();
      }
    });

    request({
      api: { method: "get", url: "Vetmed/ExpireIn3MonthOrgLicenseCount" },
      store: this.$store
    }).then(res => {
      if (res != false) {
        this.expireLics.allCount = res.data.allCount;
        this.expireLics.expireIn3MonthCount = res.data.expireIn3MonthCount;
        this.expireLics.expiredCount = res.data.expiredCount;
        if (res.data.expiredCount > 0) this.expireLics.mode = 1;
        else this.expireLics.mode = 0;

        this.initExpireLecs();
      }
    });
  },
  methods: {
    hasPermission(arr) {
      if (this.$store.state.user.userId == "") return false;
      return hasOneOf(this.$store.state.user.userInfo.access, arr);
    },
    initDashboardStats() {
      request({
        api: { method: "GET", url: "Vetmed/HomeDashboardCount" },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.dashboard = res.data;
          //console.log(res);
        }
      });
    },
    initLatestMeds() {
      let pid = 0;
      let prjs = this.$store.state.app.groupDefaultProjects.filter(
        x => x.objectTypeId == 477
      );
      if (prjs.length > 0) {
        pid = prjs[0].id;
      }
      request({
        api: { method: "post", url: "taskCore/getCoreList" },
        data: {
          projectId: pid,
          skip: 0,
          size: 10
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.importedMeds = res.data.tasks;
          //console.log(res);
        }
      });
    },
    initLatestLicences() {
      let pid = 0;
      let prjs = this.$store.state.app.groupDefaultProjects.filter(
        x => x.objectTypeId == 478
      );
      if (prjs.length > 0) {
        pid = prjs[0].id;
      }
      request({
        api: { method: "post", url: "taskCore/getCoreList" },
        data: {
          projectId: pid,
          skip: 0,
          size: 10
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.acceptedLicences = res.data.tasks;
          //console.log(res);
        }
      });
    },
    initExpireMeds() {
      this.expireMeds.list = [];
      request({
        api: { method: "get", url: "Vetmed/ExpireIn3MonthMeds" },
        params: { mode: this.expireMeds.mode },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.expireMeds.list = res.data.list;
          //console.log(res);
        }
      });
    },
    showDetail(e) {
      //console.log(e.id);
      this.taskDialog.id = e.id;
    },
    showFile(id) {
      this.fileDialog.id = id;
      this.fileDialog.show = true;
    },
    expireConfirm(id, mode) {
      this.processingObj.id = id;
      this.processingObj.item = id;
      this.processingObj.mode = mode;
      this.processing = false;
      this.busy = true;
    },
    expireCmd() {
      this.processing = true;
      request({
        api: { method: "post", url: "Vetmed/DeclineLicense" },
        data: { id: this.processingObj.id, licenseId: this.processingObj.item },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.processing = false;
          this.busy = false;
          if (this.processingObj.mode == "med") {
            this.initExpireMeds();
          } else if (this.processingObj.mode == "liv") {
            this.initExpireLecs();
          }
        }
      });
    },
    initExpireLecs() {
      this.expireLics.list = [];
      request({
        api: { method: "get", url: "Vetmed/ExpireIn3MonthOrgLicense" },
        params: { mode: this.expireLics.mode },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.expireLics.list = res.data.list;
          //console.log(res);
        }
      });
    },
    exportList(ot) {
      let _url = "";
      if (ot == 472) {
        _url = "Vetmed/MedicineReportExcel";
      } else if (ot == 463) {
        _url = "Vetmed/CompanyReportExcel";
      }
      request({
        api: { method: "POST", url: _url },
        data: {},
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.showFile(res.data.file.id);
        }
      });
    }
  }
};
</script>
